import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/recent-market-information/$zone')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/decisions/$zone', params: { zone: params.zone } });
  },
  component: () => null
});
